import React, { useMemo, useState } from 'react'

import { ButtonBase, Dialog, Slide } from '@mui/material'
import Popover from '@mui/material/Popover'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import request from '~/apis/request'
import {
  BillIcon2,
  CallWaiterIcon2,
  CloseCircleIcon,
  SearchIcon,
  SearchIcon2,
} from '~/assets/icons'
import PopupBillTablet from '~/components/PopupBillTablet'
import PopupLanguageTablet from '~/components/PopupLanguageTablet'
import PopupReadyToPay from '~/components/PopupReadyToPay'
import { fallbackLanguageCode } from '~/config/constant'
import { STATUS_CODE, languageNames, listFlagLanguages } from '~/constants'
import { selectRestaurant } from '~/redux/restaurantSlice'
import ButtonCallStaff from '~/views/CallStaff/components/ButtonCallStaff'
import PopupCallStaffReasonTablet from '~/views/CallStaff/components/PopupCallStaffReasonTablet'
import styles from './BottomBar.module.scss'
import { useNavigate } from 'react-router-dom'
import { useAppContext } from '~/contexts/AppContext'
import { path } from '~/routes/path'
import { isPartnerSmaregi } from '~/utils/externalPartner'

const cx = classNames.bind(styles)

const BottomBar = () => {
  const { isOpenSearchTablet, setIsOpenSearchTablet } = useAppContext()

  const { i18n, t } = useTranslation()
  const { restaurantId } = useSelector(selectRestaurant)
  const navigate = useNavigate()

  const currentLanguage = i18n.language

  // State dùng cho search
  const [enteredKeyword, setEnteredKeyword] = useState('')

  // State dùng cho callstaff
  const [callStaffReason, setCallStaffReason] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)

  // state dung cho popup ready to pay
  const [anchorElPopupPay, setAnchorElPopupPay] = React.useState(null)

  const openPopoverPay = Boolean(anchorElPopupPay)
  const idPay = openPopoverPay ? 'simple-popover' : undefined

  // state dungf cho chon language
  const [anchorElLanguage, setAnchorElLanguage] = React.useState(null)
  const openPopoverLanguge = Boolean(anchorElLanguage)
  const idLanguage = openPopoverLanguge ? 'simple-popover' : undefined

  // state dungf cho chon bill
  const [anchorElBill, setAnchorElBill] = React.useState(false)

  const callStaffHandler = async (event) => {
    setAnchorEl(event.currentTarget)

    try {
      const response = await request().get(`/restaurants/${restaurantId}/call_staff_reasons`)
      const { data } = response
      if (data?.data?.length > 0) {
        setCallStaffReason(data.data)
      } else {
        setCallStaffReason(false)
      }
    } catch (error) {
      if (error?.response?.status === STATUS_CODE.NOT_UNREGISTERED) {
        setCallStaffReason(false)
      }
    }
  }

  const Transition = useMemo(
    () =>
      React.forwardRef(function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />
      }),
    [],
  )

  const inputChangeHandler = (e) => {
    const { value } = e.target
    setEnteredKeyword(value)
  }

  const clearAllTextInput = () => {
    setEnteredKeyword('')

    if (!enteredKeyword) {
      setIsOpenSearchTablet(false)
    }
  }

  const handleOpenPopupSearch = () => {
    setIsOpenSearchTablet(true)
  }

  const handleClosePopupSearch = () => {
    setIsOpenSearchTablet(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    clickSearchBtnHandler()
  }

  const clickSearchBtnHandler = () => {
    setIsOpenSearchTablet(false)

    navigate({
      pathname: path.indexMenuTablet,
      search: `?search=${enteredKeyword.trim()}`,
    })
  }

  const renderInputSearch = () => {
    return (
      <form onSubmit={handleSubmit} className={cx('form_group')}>
        <ButtonBase onClick={clearAllTextInput}>
          <CloseCircleIcon background="#000" size="40" />
        </ButtonBase>
        <input
          value={enteredKeyword}
          className={cx('input')}
          onChange={inputChangeHandler}
          placeholder={t('placeholder.input_search')}
        />
        <ButtonBase onClick={clickSearchBtnHandler} className={cx('search_btn')}>
          <SearchIcon width="15.713" height="17.678" color="#fff" />
        </ButtonBase>
      </form>
    )
  }

  const renderSearchBtn = () => {
    return (
      <>
        <ButtonBase className={cx('bottom_bar_btn')} onClick={handleOpenPopupSearch}>
          <span className={cx('text')}>{t('titles.search')}</span>
          <SearchIcon2 />
        </ButtonBase>
        {isOpenSearchTablet && (
          <Dialog
            open={isOpenSearchTablet}
            TransitionComponent={Transition}
            onClose={handleClosePopupSearch}
            aria-describedby="Popup search food"
            className={cx('popup_search')}
            classes={{ container: cx('popup_search_container') }}
            PaperProps={{
              className: cx('paper_search'),
            }}>
            {renderInputSearch()}
          </Dialog>
        )}
      </>
    )
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  const renderCallStaff = () => {
    if (isPartnerSmaregi()) return null

    return (
      <>
        <ButtonBase
          aria-describedby={id}
          className={cx('bottom_bar_btn')}
          onClick={callStaffHandler}>
          <span className={cx('text')}>{t('titles.call_staff_tablet')}</span>
          <CallWaiterIcon2 />
        </ButtonBase>
        <Popover
          id={id}
          open={openPopover}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          BackdropProps={{
            invisible: false, // Make the backdrop visible
          }}
          componentsProps={{
            backdrop: {
              style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
            },
          }}
          PaperProps={{
            sx: {
              borderRadius: '15px',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
          }}>
          {!callStaffReason || callStaffReason.length === 0 ? (
            <div
              className={cx('btn_callstaff')}
              style={{
                padding: '12px 12px',
              }}>
              <ButtonCallStaff />
            </div>
          ) : (
            <PopupCallStaffReasonTablet onClosePopup={handleClose} data={callStaffReason} />
          )}
        </Popover>
      </>
    )
  }

  const handleOpenBill = () => {
    setAnchorElBill(true)
  }

  const handleCloseBill = () => {
    setAnchorElBill(false)
  }

  const renderBillBtn = () => {
    return (
      <>
        <ButtonBase className={cx('bottom_bar_btn')} onClick={handleOpenBill}>
          <span className={cx('text')}>{t('titles.bill')}</span>
          <BillIcon2 />
        </ButtonBase>
        <PopupBillTablet open={anchorElBill} onClosePopup={handleCloseBill} />
      </>
    )
  }

  const handleOpenReadyToPay = (event) => {
    setAnchorElPopupPay(event.currentTarget)
  }

  const handleCloseReadyToPay = () => {
    setAnchorElPopupPay(null)
  }

  const renderPayBtn = () => {
    if (isPartnerSmaregi()) return null

    return (
      <>
        <ButtonBase className={cx('bottom_bar_btn', 'pay')} onClick={handleOpenReadyToPay}>
          <span className={cx('text')}>{t('titles.pay')}</span>
        </ButtonBase>
        <Popover
          style={{
            borderRadius: 15,
          }}
          id={idPay}
          open={openPopoverPay}
          anchorEl={anchorElPopupPay}
          onClose={handleCloseReadyToPay}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          PaperProps={{
            sx: {
              borderRadius: '15px', // Adjust the border radius as needed
            },
          }}>
          <PopupReadyToPay onClosePopup={handleCloseReadyToPay} />
        </Popover>
      </>
    )
  }

  const handleOpenPopupLanguage = (event) => {
    setAnchorElLanguage(event.currentTarget)
  }

  const handleClosePopupLanguage = () => {
    setAnchorElLanguage(null)
  }

  const renderLanguageSelect = () => {
    const Flag = listFlagLanguages[currentLanguage] || listFlagLanguages[fallbackLanguageCode]
    const languageName = languageNames[currentLanguage] || languageNames[fallbackLanguageCode]

    return (
      <>
        <ButtonBase className={cx('bottom_bar_btn')} onClick={handleOpenPopupLanguage}>
          <span className={cx('text')}>{languageName}</span>
          <Flag size={45} />
        </ButtonBase>
        <Popover
          id={idLanguage}
          open={openPopoverLanguge}
          anchorEl={anchorElLanguage}
          onClose={handleClosePopupLanguage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          classes={{
            paper: cx('popover'),
          }}
          PaperProps={{
            sx: {
              borderRadius: '20px', // Adjust the border radius as needed
            },
          }}>
          <PopupLanguageTablet onClosePopup={handleClosePopupLanguage} />
        </Popover>
      </>
    )
  }

  // Chỉ hiển thị trong trường hợp là tablet
  const renderBackdrop = () => {
    return (
      (openPopover || openPopoverPay || openPopoverLanguge) && (
        <div className={cx('backdrop')}></div>
      )
    )
  }

  return (
    <div className={cx('wrapper')}>
      {renderSearchBtn()}
      {renderCallStaff()}
      {renderBillBtn()}
      {renderPayBtn()}
      {renderLanguageSelect()}
      {renderBackdrop()}
    </div>
  )
}

export default BottomBar
